import React, { useState } from "react";
import ResReservation3a from "./resReservation3a";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import ResReservation3b from "./resReservation3b";
import ResReservation3c from "./resReservation3c";
import { SearchResAvailability } from "../../../action/resReservation";
import { closeOrderPopUp } from "../../action/hCommerce2";
import Loader from "../../UI/loader";
import { popupOpenClose } from "../../../action/action";
import { setGoHome } from "../../action/homeAction";
import { scrollToTop } from "../../../JS/scrollToTop";


const ResReservation3 = (props) => {

    const { t } = props
    const [loading, setLoading] = useState(false);
    const [areaList, setAreaList] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [heading, setHeading] = useState(null);
    const [subHeading, setSubHeading] = useState(null);
    const [proceedNed, setProceedNext] = useState(false);
    const [servingPeriodsList, setServingPeriodList] = useState(null);
    const [selectedRestaurantData, setSelectedRestaurantData] = useState(null);
    const [restaurantsAvailability, setRestaurantsAvailability] = useState(null);
    const [createReservationData, setCreateReservationData] = useState({
        "reservationNumber": props.userInfo.reservationNumber,
        "createReservationBody": {
            "resortId": props.selectedResortId,
            "restaurantId": props.selectedRestaurantId,
            "comments": null,
            "name": props.userInfo.firstName ? props.userInfo.firstName + " " + props.userInfo.lastName : props.userInfo.lastName,
            "cancellationComments": null,
            "reservationDetails": [
                {
                    "firstName": props.userInfo.firstName || "",
                    "lastName": props.userInfo.lastName,
                    "email": props.userInfo.email,
                    "phone": props.userInfo.phone,
                    "phone2": null,
                    "address": props.userInfo.address,
                    "internalPmsReservationId": props.internalPmReservationId,
                    "customerComments": null,
                    "reservationDetailAllergies": []
                }
            ]
        }
    })


    const handleGoBack = () => {

        if (currentPage == 1) {
            props.goBack()
        }

        if (currentPage == 2) {
            setCurrentPage(1)
        }

        if (currentPage == 3) {
            setCurrentPage(2)
        }
    }



    const updateUserInfo = (payload) => {
        setCreateReservationData((prevData) => {
            const updatedReservationBody = { ...prevData.createReservationBody, ...payload.createReservationBody };

            if (payload.createReservationBody.reservationDetails && payload.createReservationBody.reservationDetails.length > 0) {
                updatedReservationBody.reservationDetails = [{...prevData.createReservationBody.reservationDetails[0], ...payload.createReservationBody.reservationDetails[0]}];
            }

            return {
                ...prevData,
                createReservationBody: updatedReservationBody,
            };
        });


        if (currentPage == 1) {
            const SearchAvailabilityPayload = {
                "date": payload.createReservationBody.dateTime,
                "restaurantIds": [+createReservationData.createReservationBody.restaurantId],
                "servingPeriodIds": [+payload.createReservationBody.servingPeriodId],
                "adults": +payload.createReservationBody.reservationDetails[0].adults,
                "children": +payload.createReservationBody.reservationDetails[0].children
            }

            showAvailableTime(SearchAvailabilityPayload);
        }

        if (currentPage == 2) {
            setCurrentPage(3);
            scrollToTop();
        }

        if (currentPage == 3) {
            setProceedNext(true);
        }
    }




    const showAvailableTime = (payload) => {

        setLoading(true);


        SearchResAvailability(payload)
            .then((res) => {
                setLoading(false);
                if (res.status == 200) {
                    if (res.data.restaurantsAvailability.length > 0) {

                        const isTimeAvailable = res.data.restaurantsAvailability.some((area) => area.sittings.some((time) => time.available));

                        if(isTimeAvailable){
                            setRestaurantsAvailability(res.data.restaurantsAvailability)
                            setCurrentPage(2)
                        } else {
                            props.popupOpenClose(true,t('resReservation.errors.no_time_slots_avail'))   
                        }
                    } else {
                        props.popupOpenClose(true,t('resReservation.errors.no_time_slots_avail'))
                    }
                } else {
                    props.closeOrderPopUp(true, t('resReservation.errors.error_fetching_restaurant_avail'), "", true)
                }
            })
            .catch((err) => { setLoading(false); props.closeOrderPopUp(true,t('resReservation.errors.error_fetching_restaurant_avail'), "", true) })
    }



    React.useEffect(() => {
        props.data.forEach((resort) => {
            if (resort.id == props.selectedResortId) {
                setHeading(resort.description)
                setServingPeriodList(resort.servingPeriodsList)
                resort.restaurantsList.forEach((restaurant) => {
                    if (restaurant.id == props.selectedRestaurantId) {
                        setAreaList(restaurant.areasList)
                        setSubHeading(restaurant.description)
                        setSelectedRestaurantData(restaurant.areasList)
                    }
                })
            }
        })


        if (props.customerExistingReservationData) {
            setCreateReservationData((prevData) => {
                return {
                    ...prevData,
                    createReservationBody: {
                        ...prevData.createReservationBody,
                        ...props.customerExistingReservationData,
                        reservationDetails: [{
                            ...prevData.createReservationBody.reservationDetails[0],
                            ...props.customerExistingReservationData.reservationDetails[0],
                            "internalPmsReservationId": props.internalPmReservationId,
                            "adults": props.customerExistingReservationData.reservationDetails[1] ? +props.customerExistingReservationData.reservationDetails[0].adults + props.customerExistingReservationData.reservationDetails[1].adults : +props.customerExistingReservationData.reservationDetails[0].adults,
                            "children": props.customerExistingReservationData.reservationDetails[1] ? +props.customerExistingReservationData.reservationDetails[0].children + props.customerExistingReservationData.reservationDetails[1].children : +props.customerExistingReservationData.reservationDetails[0].children
                        }],
                    },
                };
            });
        }
    }, [])

    React.useEffect(() => {
        if(proceedNed) {props.next(createReservationData, props.customerExistingReservationData ? true : false ); setProceedNext(false);}
    },[proceedNed])

    return (
        <div>
            <header class="inner-pages subpages">
                <a onClick={() => handleGoBack()} class="button-back"></a>
                <div class="heading align-center">
                    <p class="bold">{t('resReservation.heading2', { defaultValue: heading })}</p>
                </div>
            </header>
            {currentPage == 1 && selectedRestaurantData && servingPeriodsList && <ResReservation3a subHeading={subHeading} createReservationData={createReservationData} servingPeriodsList={servingPeriodsList} updatingCustomerDetails={props.customerExistingReservationData ? true : false} checkoutDate={props.userInfo.plannedCheckOutDate} next={(data) => updateUserInfo(data)} close={() => props.setGoHome(true)} />}
            {currentPage == 2 && restaurantsAvailability && <ResReservation3b subHeading={subHeading} areaList={areaList} customerExistingReservationData={props.customerExistingReservationData} createReservationData={createReservationData} restaurantsAvailability={restaurantsAvailability} next={(data) => updateUserInfo(data)} close={() => props.setGoHome(true)} />}
            {currentPage == 3 && <ResReservation3c subHeading={subHeading} email={props.userInfo.email} updatingCustomerDetails={props.customerExistingReservationData ? true : false} allergiesList={props.allergiesList} createReservationData={createReservationData} next={(data) => updateUserInfo(data)} close={() => props.setGoHome(true)} />}
            {loading && <Loader />}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}

export default connect(mapStateToProps, { closeOrderPopUp, popupOpenClose, setGoHome })(withTranslation('translations')(ResReservation3));